import React, { useContext } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Unauthorized from './Unauthorized'
import Index from './Index'
import { PublicIndexContext } from '../context/PublicIndexContext'

const Routing = () => {
  const context = useContext(PublicIndexContext)

  if (!context.isAuthenticated) {
    return <Unauthorized />
  }

  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Index />} />
      </Routes>
    </Router>
  )
}

export default Routing
